import React from 'react';
import styled from "@emotion/styled"
import { Link } from 'gatsby'
import parse from 'html-react-parser';
import breakpoints from '../../styles/breakpoints.js';

const SectionHeadline =({ title, subtitle }) =>
{
  return(
    <SectionHeadlineWrapper>
      <SectionHeadlineTitle className={'title'}>{parse(title)}</SectionHeadlineTitle>
      <SectionHeadlineSubtitle>{parse(subtitle)}</SectionHeadlineSubtitle>
    </SectionHeadlineWrapper>
  );

}

export default SectionHeadline;


const SectionHeadlineWrapper = styled.h2`
  margin:0;
  text-align:center;
  font-size:0;
  
  position:relative;
  z-index:2;
`

const SectionHeadlineTitle = styled.span`
  font-size: 32px;
  display:block;
  margin:0;
  line-height:1.5em;
  letter-spacing: .2em;
  text-indent: .2em;
  @media all and (max-width: ${breakpoints.xsMax}){
    font-size:24px;
    margin-bottom:6px;
  }
`

const SectionHeadlineSubtitle = styled.span`
  font-size: 16px;
  line-height:1.2em;
  letter-spacing: .3em;
  text-indent: .3em;
  color:#CCCCCC;

  @media all and (max-width: ${breakpoints.xsMax}){
    font-size:14px;
  }
`